var map = {
	"./avatar1.png": 284,
	"./avatar2.png": 948,
	"./avatar3.png": 336,
	"./avatar4.png": 903,
	"./avatar5.png": 912,
	"./avatar6.png": 220,
	"./avatar7.png": 784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 712;